import IntegratorList from './List';
import IntegratorForm from './Form';


export default {
    path: 'cadastros',
    redirect: '/cadastros/integradoras',
    name: 'Cadastro Integradoras',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [
        {
            path: 'integradoras',
            name: 'list-integrator',
            component: IntegratorList,
            meta: {
                requiresAuth: true,
                label: 'Listar Integradoras'
            }
        },
        {
            path: 'integradoras/novo',
            name: 'new-integrator',
            component: IntegratorForm,
            meta: {
                requiresAuth: true,
                label: 'Adicionar Integradora'
            }
        },
        {
            path: 'integradoras/:id',
            name: 'edit-integrator',
            component: IntegratorForm,
            meta: {
                requiresAuth: true,
                label: 'Editar Integradora'
            }
        },

    ]
}



// WEBPACK FOOTER //
// ./src/views/integrator/router.js